import { render, staticRenderFns } from "./AppLightModal.vue?vue&type=template&id=4feb19bc&scoped=true&"
import script from "./AppLightModal.vue?vue&type=script&lang=ts&"
export * from "./AppLightModal.vue?vue&type=script&lang=ts&"
import style0 from "./AppLightModal.vue?vue&type=style&index=0&id=4feb19bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feb19bc",
  null
  
)

export default component.exports